import {Component} from 'react'
import ProductCard from './ProductCard'

class ProductList extends Component {
  render() {
    const {products, onSelect} = this.props

    if (products.length === 0) {
      return (
        <p className="empty">
          No products found. Try changing search or filters.
        </p>
      )
    }

    return (
      <div className="grid">
        {products.map(product => (
          <ProductCard
            key={product.id}
            product={product}
            onClick={() => onSelect(product)}
          />
        ))}
      </div>
    )
  }
}

export default ProductList
